import { render } from "./TheMainLayout.vue?vue&type=template&id=3989c7dc"
import script from "./TheMainLayout.vue?vue&type=script&lang=js"
export * from "./TheMainLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__